import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const ProfileIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.3468 23.5513C26.1301 23.5297 25.8701 23.5297 25.6318 23.5513C20.4751 23.378 16.3801 19.153 16.3801 13.953C16.3801 8.64467 20.6701 4.33301 26.0001 4.33301C31.3085 4.33301 35.6201 8.64467 35.6201 13.953C35.5985 19.153 31.5035 23.378 26.3468 23.5513Z"
        stroke="currentColor"
        stroke-width="3.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5133 31.547C10.27 35.057 10.27 40.777 15.5133 44.2653C21.4716 48.252 31.2433 48.252 37.2016 44.2653C42.445 40.7553 42.445 35.0353 37.2016 31.547C31.265 27.582 21.4933 27.582 15.5133 31.547Z"
        stroke="currentColor"
        stroke-width="3.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ProfileIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    //small: themeValue?.fontSmlSize,
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={ProfileIconSVG}
      style={{
        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default ProfileIcon;
